export default "__VITE_PUBLIC_ASSET__b64369eb__"